var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showHeader || _vm.mainElementMainImage || _vm.showSlider
    ? _c(
        "article",
        {
          key: _vm.keyid,
          class: _vm.bemBlockMod(_vm.bannerClass),
          attrs: {
            "data-key": _vm.keyid,
            "data-banner-type": _vm.product.banner.type
          }
        },
        [
          _vm.showHeader
            ? _c("BaseTitleSubtitle", {
                class: _vm.bemElement("title-subtitle"),
                attrs: {
                  title: _vm.product.banner.mainElement.title,
                  subtitle: _vm.product.banner.mainElement.subtitle,
                  color: _vm.product.banner.mainElement.color
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.mainElementMainImage
            ? _c(
                "BaseLink",
                _vm._b(
                  { class: _vm.bemElement("link") },
                  "BaseLink",
                  _vm.product.banner.mainElement.link,
                  false
                ),
                [
                  _c("BaseImage", {
                    class: _vm.bemElement("pic"),
                    attrs: {
                      "data-url": _vm.product.banner.mainElement.link.url,
                      "image-classes": _vm.bemElement("image"),
                      image: _vm.getDefaultImageFromProductImageSet(
                        _vm.mainElementMainImage
                      ),
                      loading: _vm.forceMainImageToLoad ? "eager" : null,
                      placeholder: _vm.getPlaceholderImageFromProductImageSet(
                        _vm.mainElementMainImage
                      ),
                      sizes: _vm.getSizes(),
                      srcset: _vm.getSrcsetFromProductImageSet(
                        _vm.mainElementMainImage
                      ),
                      "use-title": false
                    },
                    on: {
                      "image-click": function($event) {
                        return _vm.mainElementClick()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showSlider
            ? _c("BaseCarousel", {
                class: _vm.bemElement("slider"),
                attrs: {
                  "are-controls-shown": false,
                  items: _vm.product.banner.productSlider,
                  "swiper-options": {
                    allowTouchMove: true,
                    loop: false,
                    slidesPerView: 2.5,
                    spaceBetween: 2
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(slotProps) {
                        return [
                          _c("BaseProductTile", {
                            attrs: {
                              "are-carousel-controls-shown": false,
                              context: _vm.context,
                              "force-main-image-to-load": true,
                              "grid-index": slotProps.index,
                              "has-carousel": false,
                              "hide-prices": _vm.hidePrices,
                              "hide-product-names": _vm.hideProductNames,
                              "hide-tags": _vm.hideTags,
                              keyid: slotProps.item.id + "-" + slotProps.index,
                              minimal: _vm.minimal,
                              product: slotProps.item,
                              "show-swatches": false,
                              type: _vm.type,
                              url: slotProps.item.selectedProductUrl || ""
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2255544108
                )
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }